{
  "appCore": {
    "common": {
      "yes": "Yes",
      "no": "No",
      "errors": {
        "notEmpty": "This field cannot be empty"
      }
    },
    "footer": {
      "state": "terms of service",
      "policy": "privacy policy"
    },
    "apps": {
      "popUp": {
        "privacyPolicy": {
          "header": "Just a moment, one more thing:",
          "text": "I declare that I have read the {state} and {policy} and agree to their terms.",
          "state": "terms of service",
          "policy": "privacy policy",
          "decline": "Cancel",
          "accept": "Yes, I agree"
        }
      },
      "event": {
        "common": {
          "underPictureText": "Show us how you are having fun, we'll laugh tomorrow!",
          "back": "Back"
        },
        "mirrorWedding": {
          "sendText": "SEND AND PRINT",
          "sendingText": "SENDING"
        },
        "wedding": {
          "sendText": "SEND",
          "sendingText": "SENDING",
          "1": {
            "sendText": "SEND PHOTOS/VIDEO"
          }
        },
        "gallery": {
          "header": "Current event gallery!",
          "name": "Gallery",
          "button": "Photo gallery",
          "subtext": "preview of uploaded photos",
          "moreFiles": "More photos",
          "changeView": "Change view",
          "loadedFiles": "Photos loaded",
          "noNewFiles": "No new files to upload. Photos in the gallery are displayed in a random order and do not necessarily appear at the end."
        },
        "sender": {
          "errors": {
            "wrongFiles": "You can send up to 20 photos or videos with a total size not exceeding 1 GB",
            "wrongFilesWithWish": "You can send a maximum of 1 photo with a total size not exceeding 1 GB",
            "default": "Error in file transmission",
            "notFiles": "No files selected"
          },
          "infos": {
            "emptyWish": "Please enter your wishes",
            "sendedFiles": "Sended all files. Thank you :)",
            "sendedProcessing": "The video will appear in the gallery after being processed by the server",
            "fileUnsupported": "Photo uploaded successfully. After sending, you will find it in the gallery.",
            "sendingProblem": {
              "sended": "Sent",
              "from": "from",
              "files": "files",
              "checkFiles": "Check the file and send it again."
            }            
          },
          "button": "Send photos/videos",
          "or": "or",
          "yourWishes": "Your wishes"
        }
      },
      "rsvp": {
        "versions": {
          "1": {
            "invitationText": "have the honor to invite",
            "placeText": "to the wedding ceremony, which will take place",
            "yearAndHour": "at",
            "in": "in",
            "0": {
              "placeText": "to the wedding ceremony, which will take place"
            },
            "1": {
              "placeText": "wedding ceremony and reception, which will take place"
            },
            "2": {
              "partyText": "WEDDING RECEPTION",
              "weddingPlace": "See the church on the map",
              "partyPlace": "See the Hall on the map"
            }
          },
          "2": {
            "wedding": "Will Be Wedding!",
            "year": "year",
            "hour": "at",
            "weddingPath": "Click to plan your route between the Church and the wedding hall:",
            "partyWelcome": "We can't wait to welcome you at our wedding!"
          }
        },
        "components": {
          "form": {
            "confirmArrival": "CONFIRM YOUR ARRIVAL",
            "main": {
              "addAnotherGuest": "Add another guest",
              "addGuest": "Confirm attendance",
              "sendRsvp": "Send confirmation",
              "edit": "EDIT",
              "name": "NAME",
              "surname": "SURNAME",
              "present": "I will be at the wedding",
              "notPresent": "I will not be at the wedding",
              "notify": {
                "error": "Data transmission error",
                "positive": "Data sent. Thank you :)",
                "notFilled": "Not all required fields are filled"
              }
            },
            "guest": {
              "guestData": "Enter your name and surname:",
              "name": "Name",
              "surname": "Surname",
              "willBePresent": "Will you be at our wedding?",
              "save": "Save"
            },
            "verions": {
              "2": {
                "historyWish": "We would like you to become part of our joint history.",
                "dueToInfo": "Please confirm your attendance by {dueToTime} by filling out the form below.",
                "confirmArrival": "Arrival confirmation",
                "guest": {
                  "guestData": "Enter your name and surname:",
                  "willBePresent": "Do you confirm your attendance?"
                }
              }
            }
          },
          "weddingWishes": {
            "title": "WEDDING WISHES"
          },
          "clockWidget": {
            "title": "Time left to the wedding",
            "clock": {
              "days": "days",
              "hours": "hours",
              "minutes": "minutes",
              "seconds": "seconds"
            }
          }
        }
      },
      "components": {
        "inputs": {
          "inputCheckboxTrueFalseSelect": {
            "selectLabel": "Select one of the following options:"
          }
        },
        "sender": {
          "sendLabel": "Add photos or videos",
          "sendWithWishLabel": "Add photo and wishes",
          "from": "from",
          "processing": "Processing",
          "notToGallery": "Do not display in the gallery"
        },
        "gks": {
          "findTable": "Find your table"
        }
      },
      "gks": {
        "header": "Seating Plan",
        "foundPlace": "Find your seat...",
        "namePlaceholder": "Enter your name",
        "personNotFound": "Person Not Found",
        "samePersonFound": "More people with a similar name were found, please continue typing...",
        "table": "Table",
        "footer": "...And then party until dawn!"
      }
    }
  },
  "loremIpsum": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
}
